export const moviesDatabase = [
  {
    id: 1,
    title: "Spider-Man: No Way Home",
    year: "2021",
    genre: "Sci-Fi/Action",
    duration: "1h 55m",
    rating: 8.2,
    votes: "12,827",
    description: "With Spider-Man's identity now revealed, Peter asks Doctor Strange for help. When a spell goes wrong, dangerous foes from other worlds start to appear, forcing Peter to discover what it truly means to be Spider-Man.",
    fullDescription: "Peter Parker's life and reputation are turned upside down when Mysterio reveals Spider-Man's identity to the world. Desperate for help, Peter turns to Doctor Strange to make the world forget that he is Spider-Man. The spell goes horribly wrong and shatters the multiverse, bringing in monstrous villains from other universes.",
    poster: "https://lh3.googleusercontent.com/aida-public/AB6AXuAdHlJYUU9IMjqHKkvh2-m-BF4aKfalcciIQ457hs9yKJDXkxwHx1Vct5Fd4JT6IZak2w5PUfpxSFMCVrKiNR-fBnZXc1mLhTgQ7YY-7oe1vxJqlHRPkPaM8WBM0zDMz6O2yEVsHp0DHCKcggJrHqg4XQrbMSpnQ1kTUhwwNoJmxL5NsrtFR8R7LiWarUbpDTuMHOIG2P0mcM7kX1W9-r7xiV0M1sf1cTLwvrqGCDw-0Lg3kKfmcBYpF_r1jTQbnqgtZ0znBM8SXA",
    backdrop: "https://lh3.googleusercontent.com/aida-public/AB6AXuAdHlJYUU9IMjqHKkvh2-m-BF4aKfalcciIQ457hs9yKJDXkxwHx1Vct5Fd4JT6IZak2w5PUfpxSFMCVrKiNR-fBnZXc1mLhTgQ7YY-7oe1vxJqlHRPkPaM8WBM0zDMz6O2yEVsHp0DHCKcggJrHqg4XQrbMSpnQ1kTUhwwNoJmxL5NsrtFR8R7LiWarUbpDTuMHOIG2P0mcM7kX1W9-r7xiV0M1sf1cTLwvrqGCDw-0Lg3kKfmcBYpF_r1jTQbnqgtZ0znBM8SXA",
    director: "Jon Watts",
    cast: ["Tom Holland", "Zendaya", "Benedict Cumberbatch", "Jacob Batalon", "Marisa Tomei"],
    categories: ["Action", "Adventure", "Fantasy"],
    language: "English",
    releaseDate: "December 17, 2021",
    budget: "$200 million",
    boxOffice: "$1.922 billion",
    trailerUrl: "https://www.youtube.com/watch?v=JfVOs4VSpmA",
    isFeatured: true,
    isNew: false,
    isPopular: true,
    isTrending: true
  },
  {
    id: 2,
    title: "Onward",
    year: "2020",
    genre: "Adventure/Family",
    duration: "1h 42m",
    rating: 7.4,
    votes: "8,456",
    description: "In a suburban fantasy world, two teenage elf brothers embark on an extraordinary quest to discover if there is still a little magic left out there.",
    fullDescription: "Set in a suburban fantasy world, two teenage elf brothers, Ian and Barley Lightfoot, go on a journey to discover if there is still a little magic left out there in order to spend one last day with their father, who died when they were too young to remember him.",
    poster: "https://lh3.googleusercontent.com/aida-public/AB6AXuB4402TlZVGwJO6PoWECV3us2rcwmhtgLuUeaA-JbDtGeTi7hniHBzso8Dm3Quht3plESqJocoHTCg8XWiCN8bZheJ_fIQr0KsOZ65XJRlmijfbrokaD5nz3OeVHJnsTeMx5F6NUcoyiG5UKrJg3ViUyqMfssOesLRNwWXDPgkewMigVJDgmH7_zNVbTtkTaRnLlv0IzyrcbezKDJFEIbwFKNlEhGG3ybDYq-xnVVWKOq19iOBadtZapjST1Qsn2Adck_P2bk9vWw",
    backdrop: "https://lh3.googleusercontent.com/aida-public/AB6AXuBnbgg1tJ3jkug1ZfesgSPHgU-C_qmVxDU-9aIg8OHFge5aoLmxhzGuJHOhQRILh26KCTOHOi1dZx3fM4mBD4X5shUig937OBnabqnOCEcvRRZqtDh9NYDCNdcmQD3qPy2SbeVu9jT8h3aynxnDRxdxYcbYLbdeDyX-66Hu5Xgk0nmc5awbPc5pgidmRYyKCbp0z1ERf_ZZLmnDbfUzB51tYXnFgEVRm6UarHz8RtgTwR44dRhnB2GT4RxYXBqS7n_9Jgc1cPMP5w",
    director: "Dan Scanlon",
    cast: ["Tom Holland", "Chris Pratt", "Julia Louis-Dreyfus", "Octavia Spencer"],
    categories: ["Animation", "Adventure", "Comedy", "Family"],
    language: "English",
    releaseDate: "March 6, 2020",
    budget: "$175 million",
    boxOffice: "$142 million",
    trailerUrl: "https://www.youtube.com/watch?v=gn5QmllRCn4",
    isPopular: true,
    isTrending: false
  },
  {
    id: 3,
    title: "Luca",
    year: "2021",
    genre: "Adventure/Comedy",
    duration: "1h 35m",
    rating: 7.5,
    votes: "6,234",
    description: "On the Italian Riviera, an unlikely but strong friendship grows between a human being and a sea monster disguised as a human.",
    fullDescription: "Set in a beautiful seaside town on the Italian Riviera, the original animated feature is a coming-of-age story about one young boy experiencing an unforgettable summer filled with gelato, pasta and endless scooter rides. Luca shares these adventures with his newfound best friend, but all the fun is threatened by a deeply-held secret: he is a sea monster from another world just below the water's surface.",
    poster: "https://lh3.googleusercontent.com/aida-public/AB6AXuC3CtE2RSFe938BWbPblCNJfniICgAYyDFEpB2b39VZDSYkcIjkz60Sf2hZ62-hbh3PU1bQ8QZGecLMsPkKPiL2eGdIeq0XgvFqY12GbZux1wZinNybt3vtE_lFHX8lGzwfnxJ3x6eMhoQPw-duNakKFozIRNLWaJ5azQC8sHtwvym1LGsnaJwAgZ88Zu63AUYAlvFCV7wPMkZT6EmJl49Nnki4k9df5W6ZYwlZ_ie63HYHZN2FAezDQclN-Iac8t1csXJjSa9fDw",
    director: "Enrico Casarosa",
    cast: ["Jacob Tremblay", "Jack Dylan Grazer", "Emma Berman", "Maya Rudolph"],
    categories: ["Animation", "Adventure", "Comedy", "Family"],
    language: "English",
    releaseDate: "June 18, 2021",
    budget: "$150 million",
    boxOffice: "$49.8 million",
    trailerUrl: "https://www.youtube.com/watch?v=mYfJxlgR2jw",
    isPopular: true,
    isNew: false
  },
  {
    id: 4,
    title: "Salma's Big Wish",
    year: "2019",
    genre: "Fantasy/Animation",
    duration: "1h 28m",
    rating: 6.8,
    votes: "1,456",
    description: "In a small Mexican town, a 16-year-old girl embarks on a magical journey to save her town.",
    fullDescription: "Salma is an orphan who has spent most of her life searching out clues about her parents. One day, she discovers a special book that is filled with stories and sets off onto an adventure with her foster brothers to find her parents.",
    poster: "https://lh3.googleusercontent.com/aida-public/AB6AXuAMdxBA9c43jTj2HS4Wwt-rlwe1xvZ11ZPkg7-Jpg0S39w7ZbtwTYcwpmMwRN_nf0wzjXyswwXZAFJc47RlW8X7myZBWTrLIHp7wRcD8XICspJ86rmtfIXwvTDqdQLpV348cOxS532wkPjLcvZ0plCb58ri-qbQN2dP4Fy_hJxF8hn1oUJTtcA70VARo1E-I8uUOyg6utc7iNyr4Z3MBBvdWzzrTDMj6kvaNDipzGHjg8VKBnbehVzrU1pBU2UMv36__jAWZtQ4sg",
    director: "Carlos Gutiérrez Medrano",
    cast: ["Jewel", "Alan Cumming", "Alfred Molina"],
    categories: ["Animation", "Fantasy", "Adventure"],
    language: "English",
    releaseDate: "November 15, 2019",
    budget: "$5 million",
    boxOffice: "$2 million",
    trailerUrl: "https://www.youtube.com/watch?v=XxD0OPyj0J8",
    isPopular: true
  },
  {
    id: 5,
    title: "Justice League",
    year: "2017",
    genre: "Adventure/Animation",
    duration: "2h",
    rating: 6.1,
    votes: "15,789",
    description: "Fueled by his restored faith in humanity, Bruce Wayne enlists the help of his newfound ally to face an even greater enemy.",
    fullDescription: "Fueled by his restored faith in humanity and inspired by Superman's selfless act, Bruce Wayne enlists the help of his newfound ally, Diana Prince, to face an even greater enemy. Together, Batman and Wonder Woman work quickly to find and recruit a team of metahumans to stand against this newly awakened threat.",
    poster: "https://lh3.googleusercontent.com/aida-public/AB6AXuBZ_TPYOSdGK1ffApQQ_7NjnzlEmgDZMoYLUo9zGUv1ZyhbDBawMMX2mdOWBRdNGosOhBue90kE6lVjjC85NATL2jLRp7AbHelDSWmvYZMEPPPkVweyLhHskZ54Hl9qQpjITwlMIHtLeAwuISvohjFcAU-fdSAOm2YJCTD0qP4rHf-u9-zsRUIaWL61Qekj-74da7AIkNIkVbITNmwlv3HTwiucm7238BXaYi1f5sLLiBJ_4qJTjRcwv6zcqMstjm_IfCIgYqp8MQ",
    director: "Zack Snyder",
    cast: ["Ben Affleck", "Gal Gadot", "Ezra Miller", "Jason Momoa", "Ray Fisher"],
    categories: ["Action", "Adventure", "Fantasy", "Sci-Fi"],
    language: "English",
    releaseDate: "November 17, 2017",
    budget: "$300 million",
    boxOffice: "$657.9 million",
    trailerUrl: "https://www.youtube.com/watch?v=r9-DM9uBtVI",
    isPopular: true,
    isTrending: true
  },
  {
    id: 6,
    title: "Oppenheimer",
    year: "2023",
    genre: "Drama/Thriller",
    duration: "3h",
    rating: 8.4,
    votes: "45,678",
    description: "The story of American scientist J. Robert Oppenheimer and his role in the development of the atomic bomb.",
    fullDescription: "During World War II, Lt. Gen. Leslie Groves Jr. appoints physicist J. Robert Oppenheimer to work on the top-secret Manhattan Project. Oppenheimer and a team of scientists spend years developing and designing the atomic bomb. Their work comes to fruition on July 16, 1945, as they witness the world's first nuclear explosion, forever changing the course of history.",
    poster: "https://lh3.googleusercontent.com/aida-public/AB6AXuCsol3CFvkU614YE_cXIlNC-FSzaL-fFrZTdjXRg6Sa_RD4GIsQurGe5L-VDZ_SudoncepTBQziA63tMmBsS-cQBrq8V7jBP3MKIeJSx6Lmo1jXfrpwjVLFvTWdHjsFcGyMm7l5Mf4IDyBkjnRzgbi3yiqsEg4CQHLIrYpRu7IDQ5uVoSgveVtjr9xJEexxh-A_rHtH6ostMZOTBM_aYUNiVxkWWvYkfkQF-g5Ysp_LBkSoy2lcyJafJSBMNLLFmaO-65KsIZuhng",
    director: "Christopher Nolan",
    cast: ["Cillian Murphy", "Emily Blunt", "Matt Damon", "Robert Downey Jr.", "Florence Pugh"],
    categories: ["Drama", "History", "Thriller"],
    language: "English",
    releaseDate: "July 21, 2023",
    budget: "$100 million",
    boxOffice: "$953 million",
    trailerUrl: "https://www.youtube.com/watch?v=uYPbbksJxIg",
    isPopular: true,
    isNew: true,
    isTrending: true
  },
  {
    id: 7,
    title: "Avengers: Endgame",
    year: "2019",
    genre: "Sci-Fi/Action",
    duration: "3h 1m",
    rating: 8.4,
    votes: "89,456",
    description: "After the devastating events of Avengers: Infinity War, the universe is in ruins. The Avengers assemble once more to reverse Thanos' actions.",
    fullDescription: "After the devastating events of Avengers: Infinity War (2018), the universe is in ruins. With the help of remaining allies, the Avengers assemble once more in order to reverse Thanos' actions and restore balance to the universe. The Avengers take a final stand in Marvel Studios' grand conclusion to twenty-two films.",
    poster: "https://lh3.googleusercontent.com/aida-public/AB6AXuCTNX_mJ6g_zINt5xGXrKHTfAXpwPYVX3mlCLfXR61zCX75ElFO1fptutBAzcAy7zqO9ELG7S8kwAZ1AdeMDzw52-6NCDbsP_ec0LLDALrIn-CBeH7_gtTN1tsyVl4wNI5-iPu0MT6WFnY6Qnp9AD0jrEL5obdYWqaZaW1T9x4KNsAXtu7bXFL63s0ZmBNYWEopPIHg9eV98ECunQp_5PkLt6B0t9GI09Zhe0UnPK-l3Tv9yw7h8KavIYKlSMQG69tFSnsephp9w",
    director: "Anthony Russo, Joe Russo",
    cast: ["Robert Downey Jr.", "Chris Evans", "Mark Ruffalo", "Chris Hemsworth", "Scarlett Johansson"],
    categories: ["Action", "Adventure", "Drama", "Sci-Fi"],
    language: "English",
    releaseDate: "April 26, 2019",
    budget: "$356 million",
    boxOffice: "$2.798 billion",
    trailerUrl: "https://www.youtube.com/watch?v=TcMBFSGVi1c",
    isPopular: true,
    isTrending: true
  },
  {
    id: 8,
    title: "Kung Fu Panda",
    year: "2008",
    genre: "Family/Comedy",
    duration: "1h 32m",
    rating: 7.6,
    votes: "12,345",
    description: "A clumsy panda bear becomes an unlikely kung fu hero when a treacherous enemy spreads chaos throughout the countryside.",
    fullDescription: "Po the Panda is the laziest of all the animals in the Valley of Peace, but unwittingly becomes the chosen one when enemies threaten their way of life. With the help of his mentor and friends, Po embarks on an incredible journey to fulfill his destiny as the Dragon Warrior.",
    poster: "https://lh3.googleusercontent.com/aida-public/AB6AXuB0zOQ8VR1BLAyARBgF4_OkpStDjf3OYGNJwJUUQcVov7uJTJOXJr5JT2qr5xUvrLZUnkp1pggustPSP-k1N-Ip-oK8IBdByjOxvk1dynrXNR_Evm3_wJwd9TjIQAkwM8XyhB9xhUGV9atw8B2mKvYSHEQxxdmo7Cn7LpYwl3Ob-AH4PV3e2Y_1XE84LCojC8MFqkFanjgN67ADjmJytVnYX0iAPq_XLZ6WAB2fPOhA1rF6E--0Uw39tPvh8D98cgxV1NcBWIwZsQ",
    director: "Mark Osborne, John Stevenson",
    cast: ["Jack Black", "Dustin Hoffman", "Angelina Jolie", "Ian McShane", "Jackie Chan"],
    categories: ["Animation", "Action", "Adventure", "Comedy", "Family"],
    language: "English",
    releaseDate: "June 6, 2008",
    budget: "$130 million",
    boxOffice: "$632 million",
    trailerUrl: "https://www.youtube.com/watch?v=PXi3Mv6KMzY",
    isNew: true,
    isPopular: true
  },
  {
    id: 9,
    title: "Tangled",
    year: "2010",
    genre: "Animation/Family",
    duration: "1h 40m",
    rating: 7.7,
    votes: "9,876",
    description: "The magically long-haired Rapunzel has spent her entire life in a tower, but now that a runaway thief has stumbled upon her.",
    fullDescription: "When the kingdom's most wanted bandit, Flynn Rider, hides in a mysterious tower, he's taken hostage by Rapunzel, a beautiful and feisty tower-bound teen with 70 feet of magical, golden hair. Together, they embark on an action-packed escapade, complete with a super-cop horse, an over-protective chameleon and a gruff gang of pub thugs.",
    poster: "https://lh3.googleusercontent.com/aida-public/AB6AXuDzDsNm5JgbvnTDUHL5E2b-HtbtKTlzGwIsUJDr-H6AZzt-qP0dtdE-CaC0Nkqc3JzbHWeeLl0apWZ2lT59hNJ2MgfwBsZgBL6mSyGGiq6kGAhwLcpnJtCMElrOgwI5_9M-PFWt11Aqk5MYLJEiBMC_T3HVjRLje7faajqxs9mKVY4Qdqp0m6FAe59kqF1k4gpCG_V8nRACeiq-drk2UxGYCAU7EFqS4lAYvhVH6di8oLl1HdUXBISMmOemjthEpj89rk_JaIUkPQ",
    director: "Nathan Greno, Byron Howard",
    cast: ["Mandy Moore", "Zachary Levi", "Donna Murphy"],
    categories: ["Animation", "Adventure", "Comedy", "Family", "Fantasy"],
    language: "English",
    releaseDate: "November 24, 2010",
    budget: "$260 million",
    boxOffice: "$592.4 million",
    trailerUrl: "https://www.youtube.com/watch?v=JYKpIr1lSG0",
    isPopular: false
  },
  {
    id: 10,
    title: "Avatar: The Way of Water",
    year: "2022",
    genre: "Sci-Fi/Adventure",
    duration: "3h 12m",
    rating: 7.6,
    votes: "34,567",
    description: "Jake Sully lives with his newfound family formed on the extrasolar moon Pandora. Once a familiar threat returns, Jake must work with Neytiri.",
    fullDescription: "Set more than a decade after the events of the first film, Avatar: The Way of Water begins to tell the story of the Sully family, the trouble that follows them, the lengths they go to keep each other safe, the battles they fight to stay alive, and the tragedies they endure.",
    poster: "https://example.com/avatar2.jpg",
    director: "James Cameron",
    cast: ["Sam Worthington", "Zoe Saldana", "Sigourney Weaver", "Stephen Lang", "Kate Winslet"],
    categories: ["Action", "Adventure", "Fantasy", "Sci-Fi"],
    language: "English",
    releaseDate: "December 16, 2022",
    budget: "$350-460 million",
    boxOffice: "$2.320 billion",
    trailerUrl: "https://www.youtube.com/watch?v=d9MyW72ELq0",
    isNew: true,
    isTrending: true
  },
  {
    id: 11,
    title: "The Batman",
    year: "2022",
    genre: "Crime/Action",
    duration: "2h 56m",
    rating: 7.8,
    votes: "28,945",
    description: "When a sadistic serial killer begins murdering key political figures in Gotham, Batman is forced to investigate the city's hidden corruption.",
    fullDescription: "In his second year of fighting crime, Batman uncovers corruption in Gotham City that connects to his own family while facing a serial killer known as the Riddler. Robert Pattinson delivers a brooding performance as the Dark Knight in this noir-inspired take on the iconic character.",
    poster: "https://example.com/batman.jpg",
    director: "Matt Reeves",
    cast: ["Robert Pattinson", "Zoë Kravitz", "Paul Dano", "Colin Farrell", "Andy Serkis"],
    categories: ["Action", "Crime", "Drama", "Mystery"],
    language: "English",
    releaseDate: "March 4, 2022",
    budget: "$185-200 million",
    boxOffice: "$770.8 million",
    trailerUrl: "https://www.youtube.com/watch?v=mqqft2x_Aa4",
    isTrending: true
  },
  {
    id: 12,
    title: "Top Gun: Maverick",
    year: "2022",
    genre: "Action/Drama",
    duration: "2h 11m",
    rating: 8.3,
    votes: "56,789",
    description: "After thirty years, Maverick is still pushing the envelope as a top naval aviator, but must confront ghosts of his past.",
    fullDescription: "After more than 30 years of service as one of the Navy's top aviators, Pete 'Maverick' Mitchell is where he belongs, pushing the envelope as a courageous test pilot and dodging the advancement in rank that would ground him. Training a detachment of graduates for a special assignment, Maverick must confront the ghosts of his past.",
    poster: "https://example.com/topgun.jpg",
    director: "Joseph Kosinski",
    cast: ["Tom Cruise", "Miles Teller", "Jennifer Connelly", "Jon Hamm", "Glen Powell"],
    categories: ["Action", "Drama"],
    language: "English",
    releaseDate: "May 27, 2022",
    budget: "$170-177 million",
    boxOffice: "$1.489 billion",
    trailerUrl: "https://www.youtube.com/watch?v=giXco2jaZ_4",
    isTrending: true
  },
  {
    id: 13,
    title: "Black Panther: Wakanda Forever",
    year: "2022",
    genre: "Action/Adventure",
    duration: "2h 41m",
    rating: 7.2,
    votes: "23,456",
    description: "The people of Wakanda fight to protect their home from intervening world powers as they mourn the death of King T'Challa.",
    fullDescription: "Queen Ramonda, Shuri, M'Baku, Okoye and the Dora Milaje fight to protect their nation from intervening world powers in the wake of King T'Challa's death. As the Wakandans strive to embrace their next chapter, the heroes must band together with Nakia and Everett Ross to forge a new path for their beloved kingdom.",
    poster: "https://example.com/blackpanther2.jpg",
    director: "Ryan Coogler",
    cast: ["Letitia Wright", "Lupita Nyong'o", "Danai Gurira", "Winston Duke", "Angela Bassett"],
    categories: ["Action", "Adventure", "Drama"],
    language: "English",
    releaseDate: "November 11, 2022",
    budget: "$250 million",
    boxOffice: "$859.2 million",
    trailerUrl: "https://www.youtube.com/watch?v=_Z3QKkl1WyM",
    isTrending: true
  }
];

// Helper functions to filter movies
export const getFeaturedMovies = () => moviesDatabase.filter(movie => movie.isFeatured);
export const getPopularMovies = () => moviesDatabase.filter(movie => movie.isPopular);
export const getTrendingMovies = () => moviesDatabase.filter(movie => movie.isTrending);
export const getNewMovies = () => moviesDatabase.filter(movie => movie.isNew);
export const getMovieById = (id) => moviesDatabase.find(movie => movie.id === parseInt(id));
export const searchMovies = (query) => {
  const lowercaseQuery = query.toLowerCase();
  return moviesDatabase.filter(movie => 
    movie.title.toLowerCase().includes(lowercaseQuery) ||
    movie.genre.toLowerCase().includes(lowercaseQuery) ||
    movie.cast.some(actor => actor.toLowerCase().includes(lowercaseQuery)) ||
    movie.director.toLowerCase().includes(lowercaseQuery)
  );
};